import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';

import useAuth from 'client/utils/auth/useAuth';

import Dialog from 'client/components/aria/Dialog/Dialog';
import Alert from 'client/components/ui/Alert/Alert';

import ButtonGroup from 'client/components/aria/ButtonGroup/ButtonGroup';
import Button from 'client/components/aria/Button/Button';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './LoggedOut.module.scss';
import { LOGGED_OUT_PARAM } from 'client/utils/routes/routeConstants';

const LoggedOut = (props) => {
    const { isAuthenticated } = useAuth();
    const intl = useIntl();
    const [isOpen, setIsOpen] = useState(false);
    const { hash } = useLocation();

    useEffect(() => {
        const loggedOut = hash === `#${LOGGED_OUT_PARAM}`;
        if (!isAuthenticated && loggedOut) {
            setIsOpen(true);
        }
    }, [hash]);

    const handleClose = () => {
        setIsOpen(false);
        window.history.replaceState({}, '', '#');
    };

    return <Dialog
        isOpen={isOpen}
        onClose={handleClose}
        isDismissable
        aria-labelledby={'loggedOut.dialog.title'}
        {...props}
        data-testid="loggedOut"
    >
        <Alert role="document">
            <h2
                id="loggedOut.dialog.title"
                data-testid="loggedOut.message"
                className={[styles.title, 'govuk-error-summary__title'].join(' ')}
            >
                {intl.formatMessage({ id: 'loggedOut.message' })}
            </h2>
            <ButtonGroup className={styles.actionRow}>
                <Button
                    data-testid="loggedOut.button"
                    onPress={handleClose}
                    variant="success"
                    aria-label={intl.formatMessage({ id: 'dismiss' })}
                >
                    {intl.formatMessage({ id: 'dismiss' })}
                </Button>
            </ButtonGroup>
        </Alert>
    </Dialog>;
};

LoggedOut.propTypes = {
    ...defaultAriaProps
};

LoggedOut.defaultProps = {
    'data-testid': 'loggedOut'
};

export default LoggedOut;
